/*===================================================================
=       BOX ASSOCIATION API                           =
====================================================================*/
/**
 * Manage the box association and box data.
 */

import axios from "axios";
import { BoxAssociationDescription, BoxDescription } from "../types/boxAssociation.types";

const BASE_URL = process.env.REACT_APP_URL_BACKEND;

/**
 * Get single box association by box association ID
 * 
 * @param boxAssoId box association id
 */
export const getSingleBoxAssociationAPI = async (boxAssoId: string) => {
  return (await axios.get<BoxAssociationDescription>(
    `${BASE_URL}/api/v2/compta/box-association/${boxAssoId}`
  )).data;
};

/**
 * Get box information from box association ID
 * 
 * @param boxAssoId box association id
 */
export const getBoxFromBoxAssociationAPI = async (boxAssoId: string) => {
  return (await axios.get<BoxDescription>(
    `${BASE_URL}/api/v2/compta/box-association/${boxAssoId}/box`
  )).data;
};

/**
 * Get box association from box ID
 * 
 * @param boxId box id
 */
export const getBoxAssociationFromBoxIdAPI = async (boxId: string) => {
  return (await axios.get<BoxAssociationDescription>(
    `${BASE_URL}/api/v2/compta/box-association/box/${boxId}`
  )).data;
};

export const BASE_BOX_ASSOCIATION_API = `${BASE_URL}/api/v2/compta/box-association`;

const boxAssociationAPI = {
  getSingleBoxAssociationAPI,
  getBoxFromBoxAssociationAPI,
  getBoxAssociationFromBoxIdAPI,
};

export default boxAssociationAPI;

